export default __webpack_public_path__ + "static/media/icon-next.f86caadb.svg";